import { ArrowDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

const HeroGridTexture = () => (
    <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
            backgroundImage:
                "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
            backgroundSize: "64px 64px",
        }}
    />
);

const HeroContent = ({ onGetStarted }) => (
    <div className="relative max-w-4xl mx-auto px-5 sm:px-8 flex flex-col items-center text-center w-full">
        <span
            className="rise-in inline-flex items-center gap-2 font-mono text-xs tracking-[-0.01em] text-black/60 border border-black/15 rounded-full px-3.5 py-1.5 mb-7"
            style={{ animationDelay: "0.1s" }}
        >
            <span className="w-1.5 h-1.5 rounded-full bg-neon animate-pulse" />
            GLOBAL AI OPTIMISATION · SME AUTOMATION
        </span>

        <h1
            data-testid="hero-headline"
            className="rise-in font-mono tracking-[-0.01em] text-black font-semibold leading-[1.04] text-4xl sm:text-5xl lg:text-6xl"
            style={{ animationDelay: "0.22s" }}
        >
            Modular AI Solutions Purpose-Built for SME growth
        </h1>

        <p
            data-testid="hero-subheadline"
            className="rise-in font-body text-base sm:text-lg text-black/70 max-w-2xl mt-7 leading-relaxed"
            style={{ animationDelay: "0.34s" }}
        >
            We believe that world-class artificial intelligence shouldn't be a
            luxury reserved only for giants. Scale smarter, move faster, and
            optimise your operations.
        </p>

        <div
            className="rise-in flex flex-wrap items-center justify-center gap-4 mt-10"
            style={{ animationDelay: "0.46s" }}
        >
            <button
                data-testid="hero-get-started"
                onClick={onGetStarted}
                className="group font-mono text-sm tracking-[-0.01em] bg-black text-white px-7 py-4 rounded-full inline-flex items-center gap-2.5 hover:bg-neon hover:text-black transition-all duration-300 hover:shadow-[0_0_28px_rgba(20,184,166,0.55)]"
            >
                CONTACT US
                <ArrowDown
                    size={16}
                    className="group-hover:translate-y-0.5 transition-transform"
                />
            </button>
        </div>
    </div>
);

export const Hero = () => {
    const navigate = useNavigate();
    return (
        <section
            id="home"
            data-testid="hero-section"
            className="relative min-h-screen flex items-center pt-28 pb-20 overflow-hidden"
        >
            <HeroGridTexture />
            <HeroContent onGetStarted={() => navigate("/contact")} />
        </section>
    );
};
